export default "__VITE_ASSET__DVOGJVZe__"